module.exports = __webpack_public_path__ + "img/xray.206a39c8.png";